<template>
  <img v-if="image" class="image" :src="src" alt="image.altText" />
</template>
<script>
export default {
  props: {
    image: {
      type: [Object],
      default: null
    },
    height: {
      type: [Number],
      default: null
    },
    width: {
      type: [Number],
      default: null
    }
  },
  computed: {
    src() {
      var src =
        process.env.VUE_APP_SALES_URL +
        '/images/image.ashx?imageId=' +
        this.image.id;
      if (this.height) {
        src += '&TargetHeight=' + this.height;
      }
      if (this.width) {
        src += '&TargetWidth=' + this.width;
      }
      return src;
    }
  }
};
</script>
